@if (showButton) {
    <button class="ace-btn btn-text has-icon fa fa-plus-circle"
            (click)="addYearModal.show()"
            helpTooltip
            tooltipText="Add Year">
    </button>
}

<div class="modal fade" bsModal #addYearModal="bs-modal" [config]="{backdrop: true}"
     tabindex="-1" role="dialog" aria-hidden="true" (onShow)="showModalInit()" (onHidden)="modalHidden()">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <ws-modal-wrapper headerLabel="Add Year"
                              acceptLabel="Add"
                              [cancelLabel]="isPrompted ? 'No' : 'Cancel'"
                              [loading]="loading"
                              [disableSave]="!saveEnabled"
                              (save)="save()"
                              (cancel)="addYearModal.hide()">
                <div class="row">
                    <div class="col-3">
                        @if (yearsList?.options) {
                            <select class="form-select form-select-sm" [ngModel]="selectedYear" (ngModelChange)="selectedYearChanged($event)" style="width: 200px;">
                                @for (option of yearsList.options; track option) {
                                    <option [disabled]="option.disabled" [ngValue]="option.year">{{ option.year }}</option>
                                }
                            </select>
                        }
                    </div>
                </div>
                @if (showTaxableValueControls) {
                    <div class="form-group mt-2">
                        <label class="display-type">
                            <input class="me-2"
                                   type="checkbox"
                                   name="autoCalculateTaxableValue"
                                   [(ngModel)]="autoCalculateTaxableValue"
                                   (change)="autoCalculateTaxableValueChanged()" />Auto Calculate TV
                        </label>
                    </div>
                    @if (autoCalculateTaxableValue) {
                        <div class="form-group">
                            <label class="display-type">
                                Calc TV Using:
                                <select class="form-select form-select-sm mt-1"
                                        style="width: 200px;"
                                        name="calcTVUsing"
                                        [(ngModel)]="calcTVUsing">
                                    <option [ngValue]="systemLogic">System Logic</option>
                                    <option [ngValue]="priorYearSetup">Prior Year Setup</option>
                                </select>
                            </label>
                        </div>
                    }
                }
            </ws-modal-wrapper>
        </div>
    </div>
</div>
